<template>
  <div class="title mt-3 text-primary">
    <span class="h5 font-weight-bold" v-text="shiur.masechta.name + ' ' + shiur.daf"></span>
    <span class="mx-1">—</span>
    <router-link :to="'/' + shiur.lecturer.url_key">
      <span class="h5">{{ shiur.lecturer.name }}</span>
    </router-link>
  </div>
</template>
<script>
export default {
  props: ['shiur'],
};
</script>

